import React from "react";
import { Rectangle } from "recharts";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { myDashboardActiveBrandStore } from "@/features/my-dashboard/stores/my-dashboard-active-brand-store";

function MyDashboardActiveCursor(props: any) {
  const activeBrand = useRecoilValue(myDashboardActiveBrandStore);
  if (props.formattedGraphicalItems.length === 0) return null;

  const { top, width, height, data } = props.formattedGraphicalItems[0].props;
  const brandList = props.data;

  const selectedIdx = brandList.findIndex(
    (item: any) => item.brand_id === activeBrand.brandId
  );

  const left = (data.length === 0 ? 0 : data?.[1].x - data[0].x) * selectedIdx;

  return (
    <Rectangle
      x={left === 0 ? 0.5 : left}
      y={top}
      width={width / 10}
      height={height - 1}
      // 안쪽은 아주 연한 색으로, 테두리는 파란색으로
      fill="#F7F9FA" // 혹은 "none" 으로 해서 완전 투명하게도 가능
      stroke="#1272EF"
      strokeWidth={1}
      radius={6} // 모서리 둥글게
      cursor={"pointer"}
    />
  );
}

export default MyDashboardActiveCursor;
